// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type LotCheckTableMetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LotCheckTableMetadataQuery = { __typename?: 'Query', siteSpecificInfos: Array<{ __typename?: 'SiteSpecificInfo', id: string, description: string }> };

export type SaveProjectSiteSpecificInfoMutationVariables = Types.Exact<{
  input: Types.SaveProjectSiteSpecificInfoInput;
}>;


export type SaveProjectSiteSpecificInfoMutation = { __typename?: 'Mutation', saveProjectSiteSpecificInfo: { __typename?: 'SaveProjectSiteSpecificInfoResult', projectSiteSpecificInfo: { __typename?: 'ProjectSiteSpecificInfo', id: string } } };


export const LotCheckTableMetadataDocument = gql`
    query LotCheckTableMetadata {
  siteSpecificInfos {
    id
    description
  }
}
    `;

/**
 * __useLotCheckTableMetadataQuery__
 *
 * To run a query within a React component, call `useLotCheckTableMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotCheckTableMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotCheckTableMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useLotCheckTableMetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LotCheckTableMetadataQuery, LotCheckTableMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotCheckTableMetadataQuery, LotCheckTableMetadataQueryVariables>(LotCheckTableMetadataDocument, options);
      }
export function useLotCheckTableMetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotCheckTableMetadataQuery, LotCheckTableMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotCheckTableMetadataQuery, LotCheckTableMetadataQueryVariables>(LotCheckTableMetadataDocument, options);
        }
export function useLotCheckTableMetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<LotCheckTableMetadataQuery, LotCheckTableMetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<LotCheckTableMetadataQuery, LotCheckTableMetadataQueryVariables>(LotCheckTableMetadataDocument, options);
        }
export type LotCheckTableMetadataQueryHookResult = ReturnType<typeof useLotCheckTableMetadataQuery>;
export type LotCheckTableMetadataLazyQueryHookResult = ReturnType<typeof useLotCheckTableMetadataLazyQuery>;
export type LotCheckTableMetadataSuspenseQueryHookResult = ReturnType<typeof useLotCheckTableMetadataSuspenseQuery>;
export type LotCheckTableMetadataQueryResult = Apollo.QueryResult<LotCheckTableMetadataQuery, LotCheckTableMetadataQueryVariables>;
export const SaveProjectSiteSpecificInfoDocument = gql`
    mutation SaveProjectSiteSpecificInfo($input: SaveProjectSiteSpecificInfoInput!) {
  saveProjectSiteSpecificInfo(input: $input) {
    projectSiteSpecificInfo {
      id
    }
  }
}
    `;
export type SaveProjectSiteSpecificInfoMutationFn = Apollo.MutationFunction<SaveProjectSiteSpecificInfoMutation, SaveProjectSiteSpecificInfoMutationVariables>;

/**
 * __useSaveProjectSiteSpecificInfoMutation__
 *
 * To run a mutation, you first call `useSaveProjectSiteSpecificInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveProjectSiteSpecificInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveProjectSiteSpecificInfoMutation, { data, loading, error }] = useSaveProjectSiteSpecificInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveProjectSiteSpecificInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveProjectSiteSpecificInfoMutation, SaveProjectSiteSpecificInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveProjectSiteSpecificInfoMutation, SaveProjectSiteSpecificInfoMutationVariables>(SaveProjectSiteSpecificInfoDocument, options);
      }
export type SaveProjectSiteSpecificInfoMutationHookResult = ReturnType<typeof useSaveProjectSiteSpecificInfoMutation>;
export type SaveProjectSiteSpecificInfoMutationResult = Apollo.MutationResult<SaveProjectSiteSpecificInfoMutation>;
export type SaveProjectSiteSpecificInfoMutationOptions = Apollo.BaseMutationOptions<SaveProjectSiteSpecificInfoMutation, SaveProjectSiteSpecificInfoMutationVariables>;